import { render, staticRenderFns } from "./FormSelectbox.vue?vue&type=template&id=b9884cca"
import script from "./FormSelectbox.vue?vue&type=script&lang=js"
export * from "./FormSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports